import { useQuery } from '@tanstack/react-query';
import type { paths } from '../../../generated/apiClient';
import { repositoryGetter } from '../../../repository/container';
import { UseQueryDefaultOptions } from '../common';

const repository = repositoryGetter.Auth();
const apiPath: Extract<keyof paths, '/auth/is-allowed-ip'> = '/auth/is-allowed-ip';
export const queryKey = (props: Props) => [apiPath, props];

type Props = { projectId: string };

export const _isAllowedIp = (props: Props) => {
  const { projectId } = props;

  const { data, isPending, refetch, error } = useQuery({
    queryKey: queryKey(props),
    queryFn: async ({ signal }) => {
      return repository.isAllowedIp({ projectId, signal });
    },
    ...UseQueryDefaultOptions,
    throwOnError: false,
    // 5 min
    staleTime: 1000 * 60 * 5,
    // 10 min
    gcTime: 1000 * 60 * 10,
  });

  return { isAllowedIp: data, isPending, refetch, error };
};
